// ProfileSection.jsx

// Dependencies
import React from 'react';

// Styling
import { homeCss } from '@digital_monorepo/styling';

const ProfileSection = ({ fields, data }) => {
  return (
    <div className={homeCss.profile}>
      {fields.map((field, index) => (
        <p className={homeCss.singleLineLeft}>
          <span className={homeCss.label}>{field}:</span>
          {React.isValidElement(data[index]) ? React.cloneElement(data[index]) : data[index]}
        </p>
      ))}
    </div>
  );
};

export default ProfileSection;
